import React, { Fragment } from 'react'
import './index.less'
class EmployeeEntrance extends React.Component {
      toGs = () => {
          const { buriedPointEvent, data: { position, trackId, sublist: [{ id, realNameFlag }] } } = this.props
          const isRealname = realNameFlag === 'Y' ? '1' : '0'
          buriedPointEvent({
              button_name: `${trackId}`,
              button_id: `${id}`,
              button_order: '1',
              area_order: position,
              button_area: `${position}-${trackId}`
          })
          const HTML_LINK = process.env.REACT_APP_HTML_LINK
          const pageLink = `${HTML_LINK}gs-index?Source=inside&isRealname=${isRealname}`
          window.GomeJSBridge.pushWindow(null, null, pageLink)
      }

      render () {
          const { data: { sublist } } = this.props
          return (
              <Fragment>
                  {
                      sublist.map((item, index) => {
                          return (
                              <div
                                  className={'myAssetContainer statistics-dom'}
                                  key={index}
                                  style={{
                                      background: '#fff'
                                  }}
                                  onClick={this.toGs}
                              >
                                  <div className={'myAssetLeft'}>
                                      <img className={'myYikaIcon'} src={item.iconUrl} alt='' ></img>
                                  </div>
                                  <div
                                      className={'myAssetRight'}
                                  >
                                      {/* <span className={'myAssetRightOne'}>{item.name}</span> */}
                                      {/* {!item.nearly7DayAmount && item.businessLine === '0931' ? (<span className={'myAssetRightOne'}>全部账单</span>)
                                          : (<span className={'myAssetRightOne'}>{this.handleData(item.cuePhrases)}</span>)}

                                      {item.nearly7DayAmount !== null && item.nearly7DayAmount !== '0' && item.businessLine === '0931'
                                          ? (<span className={'myAssetRightTwo'}>{item.nearly7DayAmount}</span>) : null} */}
                                      <span className={'myAssetRightThree'} />
                                  </div>
                              </div>
                          )
                      })
                  }
              </Fragment>

          )
      }
}

export default EmployeeEntrance
